// 패스픽 시작 가이드의 영속 상태 타입.
// 실제 서비스 상태(담은 상품/신청/주문)와 절대 섞이지 않는다 — 전부 브라우저 저장소에만 산다.

// 상단 단계 탭 7개. 저장된 값이 이 목록에 없으면 첫 단계로 복구한다.
export const START_GUIDE_STEPS = [
  "setup",
  "product_tour",
  "workbench",
  "after_order",
  "membership",
  "faq",
  "finish",
] as const;
export type StartGuideStep = (typeof START_GUIDE_STEPS)[number];

// `신청 후 이용`(KREAM 전용: `주문 후 이용`) 탭 안의 진행 화면.
// 탭과 같은 층위의 위치라 함께 저장한다 —
// 새로고침해도 보던 안내가 유지돼야 하기 때문이다. 실제 순서는 판매 방식마다 다르다.
export const START_GUIDE_AFTER_ORDER_PAGES = [
  "requestHistory",
  "order",
  "orderDetail",
] as const;
export type StartGuideAfterOrderPage =
  (typeof START_GUIDE_AFTER_ORDER_PAGES)[number];

// 판매 방식 — 셋 중 하나만 고른다(라디오). 저장값이 곧 화면 분기값이다.
// 설정 목록·담은 상품 작업 패널·신청 후 이용 3화면이 모두 이 값 하나로 갈린다.
// 등록 신청 내역은 셋이 서로 다른 얼굴을 갖고(연동 관리 / 엑셀 다운로드 / KREAM 다운로드),
// 주문 상세는 KREAM 여부로만 갈린다.
export const START_GUIDE_SALES_MODES = ["api", "file", "kream"] as const;
export type StartGuideSalesMode = (typeof START_GUIDE_SALES_MODES)[number];

// 스마트스토어 개설 여부 — 미응답(null)이면 사전 확인 화면을 다시 보여준다.
export const SMART_STORE_PRESENCES = ["has_store", "no_store"] as const;
export type StartGuideSmartStorePresence =
  (typeof SMART_STORE_PRESENCES)[number];

// 설정 태스크 id. 판매 방식에 따라 이 중 일부만 노출된다.
export const READINESS_TASK_IDS = [
  "product_type",
  "overseas_permission",
  "overseas_release",
  "api_setting",
  "delivery_template",
  "buyer_info",
] as const;
export type StartGuideReadinessTaskId = (typeof READINESS_TASK_IDS)[number];

export interface StartGuideState {
  version: number;
  // 설정 단계의 구성/의미가 바뀌면 올린다 — 이전 완료 상태를 버리기 위한 값이다.
  readinessRevision: number;
  salesMode: StartGuideSalesMode;
  // 판매 방식을 한 번이라도 저장했는지 — false면 판매 방식 선택 화면을 보여준다.
  hasSavedProfile: boolean;
  smartStorePresence: StartGuideSmartStorePresence | null;
  // 사전 확인(판매자센터 열기/개설 완료)을 사용자가 직접 완료 표시했는지.
  isPreflightConfirmed: boolean;
  completedTasks: StartGuideReadinessTaskId[];
  currentStep: StartGuideStep;
  // 후단계 탭 안에서 보던 화면. 지금 판매 방식에 없는 값이면 그 흐름의 첫 화면으로 보정한다.
  afterOrderPage: StartGuideAfterOrderPage;
  // 무료체험 시작 시각(ISO). Phase 5에서 48시간 계산에 쓴다.
  freeTrialStartedAt: string | null;
}
